module.exports = __webpack_public_path__ + "media/images/phi2-1ddc44d54faab7c5af15358d905be0fa.jpg";